import { MarkingService } from "@/services/api/marking.api.service"

// chestny znak: settings of the clinic and the counters of the warehouse indicator.
// Loaded only for users with the chestny_znak right, without them the warehouse works as before
const state = {
    markingSettings: null,
    markingCounters: null,
    // codes of the opened income / movement document, per material
    markingDocument: { progress: [], codes: {} },
    // codes scanned in the opened visit, per material
    markingVisit: { recordId: null, materials: [] },
    // the registry code whose history is shown
    markingHistoryCodeId: null,
}

const getters = {
    markingEnabled(state, getters, rootState) {
        return (rootState.auth.rights || []).includes('chestny_znak') && !!state.markingSettings?.enabled
    },
    markingVisitByMaterial(state) {
        const map = {}
        for(const row of state.markingVisit.materials || []) map[row.material_id] = row
        return map
    },
    markingProgressByMaterial(state) {
        const map = {}
        for(const row of state.markingDocument.progress || []) map[row.material_id] = row
        return map
    },
}

const mutations = {
    setMarkingSettings(state, settings) {
        state.markingSettings = settings
    },
    setMarkingCounters(state, counters) {
        state.markingCounters = counters
    },
    setMarkingHistoryCodeId(state, id) {
        state.markingHistoryCodeId = id
    },
    setMarkingVisit(state, { recordId, materials }) {
        state.markingVisit = { recordId, materials: materials || [] }
    },
    setMarkingDocument(state, data) {
        state.markingDocument = {
            progress: data?.progress || [],
            codes: Array.isArray(data?.codes) ? {} : (data?.codes || {}),
        }
    },
}

const actions = {
    async loadMarkingSettings({ commit, rootState, state }, force = false) {
        if(!(rootState.auth.rights || []).includes('chestny_znak')) return null
        if(state.markingSettings && !force) return state.markingSettings
        try {
            const res = await MarkingService.getSettings()
            commit('setMarkingSettings', res.data)
            return res.data
        } catch (e) {
            return null
        }
    },
    async loadMarkingCounters({ commit, getters }) {
        if(!getters.markingEnabled) return null
        try {
            const res = await MarkingService.getDashboard()
            commit('setMarkingCounters', res.data)
            return res.data
        } catch (e) {
            return null
        }
    },
    async loadMarkingVisit({ commit, getters }, recordId) {
        if(!getters.markingEnabled || !recordId) return
        try {
            const res = await MarkingService.getVisit(recordId)
            commit('setMarkingVisit', { recordId, materials: res.data.materials })
        } catch (e) {
            commit('setMarkingVisit', { recordId, materials: [] })
        }
    },
    async loadMarkingDocument({ commit, getters }, documentId) {
        if(!getters.markingEnabled || !documentId) {
            commit('setMarkingDocument', null)
            return
        }
        try {
            const res = await MarkingService.getDocumentCodes(documentId)
            commit('setMarkingDocument', res.data)
        } catch (e) {
            commit('setMarkingDocument', null)
        }
    },
};

export default {
    state,
    actions,
    mutations,
    getters
}
